function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17 11.9683C14.245 11.9683 12 14.2133 12 16.9683C12 19.7233 14.245 21.9683 17 21.9683C19.755 21.9683 22 19.7233 22 16.9683C22 14.2133 19.755 11.9683 17 11.9683ZM16.625 14.9683C16.625 14.7633 16.795 14.5933 17 14.5933C17.205 14.5933 17.375 14.7633 17.375 14.9683V17.4683C17.375 17.6733 17.205 17.8433 17 17.8433C16.795 17.8433 16.625 17.6733 16.625 17.4683V14.9683ZM17.46 19.1583C17.435 19.2233 17.4 19.2733 17.355 19.3233C17.305 19.3683 17.25 19.4033 17.19 19.4283C17.13 19.4533 17.065 19.4683 17 19.4683C16.935 19.4683 16.87 19.4533 16.81 19.4283C16.75 19.4033 16.695 19.3683 16.645 19.3233C16.6 19.2733 16.565 19.2233 16.54 19.1583C16.515 19.0983 16.5 19.0333 16.5 18.9683C16.5 18.9033 16.515 18.8383 16.54 18.7783C16.565 18.7183 16.6 18.6633 16.645 18.6133C16.695 18.5683 16.75 18.5333 16.81 18.5083C16.93 18.4583 17.07 18.4583 17.19 18.5083C17.25 18.5333 17.305 18.5683 17.355 18.6133C17.4 18.6633 17.435 18.7183 17.46 18.7783C17.485 18.8383 17.5 18.9033 17.5 18.9683C17.5 19.0333 17.485 19.0983 17.46 19.1583Z",
  fill: "#F44336"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10 12.9683C12.2091 12.9683 14 11.1774 14 8.96826C14 6.75912 12.2091 4.96826 10 4.96826C7.79086 4.96826 6 6.75912 6 8.96826C6 11.1774 7.79086 12.9683 10 12.9683Z",
  fill: "#F44336"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.67 13.9883C10.45 13.9783 10.23 13.9683 10 13.9683C7.58 13.9683 5.32 14.6383 3.39 15.7883C2.51 16.3083 2 17.2883 2 18.3183V20.9683H11.26C10.47 19.8383 10 18.4583 10 16.9683C10 15.8983 10.25 14.8983 10.67 13.9883Z",
  fill: "#F44336"
});

function SvgSuicidalPatients(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuicidalPatients);
export default __webpack_public_path__ + "static/media/suicidal-patients.97b21761.svg";
export { ForwardRef as ReactComponent };